import { Container as MUIContainer } from "@mui/material";

export default function Container({ children, sx = {} }) {
  return (
    <MUIContainer
      maxWidth="xl"
      sx={{
        px: ["9.6rem"],
        ...sx
      }}
    >
      {children}
    </MUIContainer>
  );
}
